import { VariantProps } from 'tailwind-variants';

import SuccessIcon from '@/fo/icons/base/icons/check24.svg';

import { styles } from './ProductSliderInfo.styles';

type Variants = VariantProps<typeof styles>;

export type InfoProduct = {
  label: React.ReactNode;
  description?: React.ReactNode;
};

export interface ProductSliderInfoProps {
  items: InfoProduct[];
  mode: Variants['mode'];
}

export function ProductSliderInfo({ items, mode }: ProductSliderInfoProps) {
  const slots = styles({ mode });

  return (
    <div className={slots.base()}>
      <div className={slots.center()}>
        {items.map((item, index) => {
          const itemSlots = styles({ index: index as 0 | 1 | 2, mode });

          return (
            <div
              className={itemSlots.item()}
              key={index}
            >
              <div className={itemSlots.wrap()}>
                <div className={itemSlots.content()}>
                  <div className={itemSlots.title()}>{item.label}</div>
                  {item.description && (
                    <div className={itemSlots.description()}>
                      {item.description}
                    </div>
                  )}
                </div>
                <div className={itemSlots.ellipse()}>
                  <div className={itemSlots.ellipseInner()}>
                    <SuccessIcon className={itemSlots.icon()} />
                  </div>
                </div>
              </div>
              {item.description && (
                <div className={itemSlots.mobileDescription()}>
                  {item.description}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
